module.exports = __webpack_public_path__ + "img/carmela.a5fa6f81.png";